import { useState } from "react"
import { CenterPopupContainer, CenterPopup, FlexRow, CustomContainer, AppText, AppSpan, Form, FormGroup, Button } from "src/style"
import { VscChromeClose } from "react-icons/vsc"

export const SuspensionReason: React.FC<any> = ({close, onSuspendClick}) => {
    const [reason, setReason] = useState('')
    const [isHover, setIsHover] = useState(false)

    async function handleSuspend(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        onSuspendClick(reason)
        close()
    }
    
    return (
        <CenterPopupContainer>
            <CenterPopup data-aos="zoom-in">
                <FlexRow 
                    gap="3.5" 
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <CustomContainer 
                        width="auto" sizeUnit=""
                        style={{maxWidth: '32rem'}}
                    >
                        <AppText 
                            textSize="1.6" 
                            color="#181D27" 
                            fontWeight="700"
                        >
                            Reason for suspending company
                        </AppText>
                        <AppSpan color="#6E7985">
                            A vitae vitae enim varius tortor suspendisse sagittis enim integer.
                        </AppSpan>
                    </CustomContainer>
                    <VscChromeClose 
                        fontSize='1.6rem' color={isHover ? '#EB5757' : '#000000'}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                        onClick={close}
                    />
                </FlexRow>
                <Form onSubmit={handleSuspend} topMargin='2'>
                    <FormGroup 
                        height="18.1" bgColor="#EFEFEF"
                    >
                        <textarea 
                            placeholder="Your reason"
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </FormGroup>
                    <FlexRow 
                        justifyContent='flex-end' gap="1"
                        // topMargin='5'
                    >
                        <Button 
                            width='13.2' 
                            hoverBgColor='#ffffff'
                            bgColor="#ffffff" 
                            hoverBorderColor='#5627FF'
                            hoverColor='#5627FF'
                            color="#5627FF"
                            type="button"
                            onClick={close}
                        >
                            Cancel
                        </Button>
                        <Button 
                            width='15.4' 
                            hoverBgColor='#ffffff' 
                            hoverColor='#5627FF'
                            borderColor='#5627FF'
                        >
                            Suspend
                        </Button>
                    </FlexRow>
                </Form>
            </CenterPopup>
        </CenterPopupContainer>
    )
} 